import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { EXTERNAL_URLS } from '../../../../shared/config/external-urls';

@Component({
  selector: 'app-ngs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ngs.component.html',
  styleUrl: './ngs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgsComponent {

  constructor(private router: Router) {}

  ngOnInit(): void {
    window.open(EXTERNAL_URLS.ngsServiceRequests, '_self');
    this.router.navigate(['/home']);
  }

}
